<template>
  <div>
    <input
      v-model.trim="search"
      ref="search"
      type="text"
      :placeholder="$t('purchaseOrder.searchProductList')"
      class="form-control"
    />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded">
      <ts-loading-banner :loading="loading">
        <div class="max-h">
          <table class="ts-w-full">
            <thead>
              <tr>
                <th style="width: 13%;">
                  {{ $t('purchaseRequest.productGroup') }}
                </th>
                <th style="width: 13%;">
                  {{ $t('purchaseRequest.barcode') }}
                </th>
                <th style="width: 24%;">
                  {{ $t('purchaseRequest.productName') }}
                </th>
                <th style="width: 13%;">
                  {{ $t('purchaseRequest.uom') }}
                </th>
                <th style="width: 13%;">
                  {{ $t('purchaseRequest.quantity') }}
                </th>
                <th style="width: 20%;">
                  {{ $t('purchaseRequest.unitPrice') }}
                </th>
                <th style="width: 4%;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in products" :key="index">
                <td>{{ product.pro_group_name_en }}</td>
                <td>{{ product.barcode }}</td>
                <td>{{ product.product_name_en }}</td>
                <td>
                  <a-select
                    v-model="product.uom_id"
                    :options="getUnitOfMeasures(product.uom_cat_id)"
                    option-filter-prop="children"
                    class="ts-w-full"
                    placeholder="Select"
                  ></a-select>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control ts-text-center"
                    v-model.number="product.quantity"
                  />
                </td>
                <td class="ts-text-right">
                  <ts-currency-input
                    :value="product.input_unit_price"
                    class="form-control ts-text-right"
                    style="min-width: 100px;"
                    :currency="defaultCurrency.currency_symbol"
                    :precision="defaultCurrency.currency_rounding"
                    :disabled="true"
                  />
                </td>
                <td class="ts-text-center ts-cursor-pointer">
                  <a
                    href="#"
                    class="ts-text-blue-500"
                    @click.prevent="addItem(product)"
                  >
                    <i class="fa fa-plus"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-loading-banner>
    </div>
    <small>
      <i>{{ $t('purchaseRequest.clickToAddProduct') }}</i>
    </small>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      loading: false,
      search: '',
      model: {},
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
          .filter(
            ei =>
              this.search
                .split(' ')
                .every(s =>
                  ei.barcode.toLowerCase().includes(s.toLowerCase())
                ) ||
              this.search
                .split(' ')
                .every(s =>
                  ei.product_name_en.toLowerCase().includes(s.toLowerCase())
                )
          )
          .slice(0, 20)
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    },
    defaultCurrency() {
      if (this.$store.state.exchangeRate.currency.formViewDatas['default']) {
        return this.$store.state.exchangeRate.currency.formViewDatas['default']
      }
      return {
        currency_symbol: '$',
        currency_rounding: 2
      }
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    getUnitOfMeasures(uom_cat_id) {
      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    addItem(product) {
      let row = {
        product_id: product.product_id,
        uom_id: product.uom_id,
        uom_cat_id: product.uom_cat_id,
        quantity: product.quantity ? product.quantity : 1,
        maximum_reorder_allow: product.maximum_reorder_allow,
        alloworder: false,
        input_currency_id: product.input_currency_id,
        currency_id: product.currency_id,
        fx_rate: product.fx_rate,
        fx_rate_ratio: product.fx_rate_ratio,
        input_unit_price: product.input_unit_price
          ? product.input_unit_price
          : 0,
        unit_price: product.unit_price ? product.unit_price : 0,
        input_total: product.input_unit_price * product.quantity,
        total: product.unit_price * product.quantity,
        remarks: null,
        order: this.model.details.length
      }
      this.model.details.push(row)
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 60vh;
  max-height: 60vh;
  overflow-y: scroll;
}

.form-control {
  height: 32px;
}

table {
  width: 100%;
}

table thead tr {
  border-width: 1px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
}

table thead tr th {
  white-space: nowrap;

  background-color: #edf2f7;

  padding-left: 0.25rem /* 12px */;
  padding-right: 0.25rem /* 12px */;

  padding-top: 0.25rem /* 4px */;
  padding-bottom: 0.25rem /* 4px */;
}

table tbody tr {
  cursor: pointer;
  border-width: 1px;
}

table tbody tr:hover {
  background-color: #e2e8f0;
}

table tbody tr td {
  white-space: nowrap;

  padding-top: 0.25rem /* 4px */;
  padding-bottom: 0.25rem /* 4px */;

  padding-left: 0.25rem /* 4px */;
  padding-right: 0.25rem /* 4px */;

  border-right-width: 1px;
}
</style>
